export class Troubleshootingqa {
  sn: number = null;
  name: string = "";
  cat: string = "";
  id: string = null;

  getSn() {
    return this.sn;
  }

  getName() {
    return this.name;
  }

  getId() {
    return this.id;
  }

  getCat() {
    return this.cat;
  }

  setSn(sn: number) {
    this.sn = sn;
  }

  setName(name: string) {
    this.name = name;
  }

  setId(id: string) {
    this.id = id;
  }

  setCat(cat: string) {
    this.cat = cat;
  }
}
